import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import alertUtil from './alertUtil';
import classList from '../../common/utils/classList';
import Alert, { AlertAttrs } from '../../common/components/Alert';

export default class PushFrontModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.addExperience = Stream(1);
    this.discussion = this.attrs.discussion;
    this.isFront = this.attrs.isFront;

    this.addIntegra = Stream(1);
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small';
  }

  title() {
    return app.translator.trans('dl_discussion_controller.forum.pushFrontModal.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group position-counter">
            <label>{app.translator.trans('dl_discussion_controller.forum.pushFrontModal.add_experience')}:</label>
            <input required type="number" min="1" max="1000" name="addExperience" className="FormControl" bidi={this.addExperience} disabled={this.loading} />
          </div>
          <div className="Form-group position-counter">
            <label>{app.translator.trans('dl_discussion_controller.forum.pushFrontModal.add_integra')}:</label>
            <input required type="number" min="1" name="addIntegra" className="FormControl" bidi={this.addIntegra} disabled={this.loading} />
          </div>
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
              {app.translator.trans('dl_discussion_controller.forum.pushFrontModal.submit')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onSuccess(text) {
    app.alerts.show({ type: 'success', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  }

  onWarn(text) {
    app.alerts.show({ type: 'warn', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  }

  onsubmit(e) {
    e.preventDefault();
    let alertText = app.translator.trans('dl_discussion_controller.forum.pushFrontModal.submit_success');
    if (app.session?.user?.isAdmin()) {
      alertText = app.translator.trans('dl_discussion_controller.forum.pushFrontModal.admin_submit_success');
    }
    if (!this.addIntegra() || !this.addExperience() ) {
      alertText = app.translator.trans('dl_discussion_controller.forum.pushFrontModal.empty_value');
      this.onWarn(alertText);
      return;
    }
    let myObject = {
        'addIntegra': this.addIntegra(),
        'addExperience': this.addExperience(),
    };
    this.loading = true;
    this.discussion
    .save({ 
      frontpage: this.isFront,
      myObject: myObject,
    })
    .then(()=>{
      this.onSuccess(alertText);
      this.hide();
    })
    .catch(() => {
      this.loading = false;
      m.redraw();
    });
   
  }

}
